export const initTabsToDropdown = () => {
  document.querySelectorAll('.nav.nav-tabs.to-dropdown').forEach(tab => {
    let overviewText = "Overview"; // Default overview text
    let dropdownItems = '';
    const tabs = tab.querySelectorAll('.nav-item');

    if (tabs.length <= 1) {
      return;
    }

    tabs.forEach((item, index) => {
      const link = item.querySelector('.nav-link');
      const isActive = link.classList.contains('active');
      const hash = link.hash;

      // Use the index to associate the dropdown item with the original tab
      dropdownItems += `<li><a class="dropdown-item" data-index="${index}" data-tab-name="${hash}">${link.textContent}</a></li>`;

      if (isActive || (index === 0 && overviewText === "Overview")) {
        overviewText = link.textContent;
      }
    });

    // Create the dropdown structure
    let dropdown = `
    <div class="btn-group tab-switcher ${tab.classList.contains('mb-0') ? 'mb-0' : 'mb-4'}">
      <button class="btn btn-secondary bg-olive-green dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <small>Select an option</small> ${overviewText} <i class="far fa-chevron-down"></i>
      </button>
      <ul class="dropdown-menu">${dropdownItems}</ul>
    </div>`;

    // Insert the dropdown after the original tabs
    tab.insertAdjacentHTML('afterend', dropdown);
  });

  // Add a click event listener for the dropdown items
  document.addEventListener('click', function (event) {
    if (event.target.matches('.dropdown-item')) {
      const index = event.target.getAttribute('data-index');

      if (event.target.closest('.btn-group')) {
        const tab = event.target.closest('.btn-group').previousElementSibling;
        const originalTabItem = tab.querySelectorAll('.nav-item')[index].querySelector('.nav-link');

        // Get the dropdown button
        const dropdownButton = event.target.closest('.btn-group').querySelector('.dropdown-toggle');

        // Change the text content of the dropdown button to the selected tab's text
        const selectedText = originalTabItem.textContent;
        dropdownButton.innerHTML = `<small>Select an option</small> ${selectedText} <i class="far fa-chevron-down"></i>`;

        // Simulate a click on the original tab item
        originalTabItem.click();
        event.preventDefault();
      }
    }
  });

  // Attempt to focus a tab if there's a hash on the window location.
  // Click the tab if it exists. The dropdown-item has a data-tab-name that matches the hash.
  const hash = window.location.hash;

  if (hash) {
    const tab = document.querySelector(`.dropdown-item[data-tab-name="${hash}"]`);

    if (tab) {
      tab.click();
    }
  }
};
